<div class="controls">
    <button mat-mini-fab color="primary" class="zoom-in" (click)="zoomIn()"><mat-icon>zoom_in</mat-icon></button>
    <button mat-mini-fab color="primary" class="zoom-out" (click)="zoomOut()"><mat-icon>zoom_out</mat-icon></button>
        <button mat-mini-fab color="warn" class="close" (click)="close()"><i class="material-icons" data-icon="close"></i></button>
</div>
<div mat-dialog-content>
    <div class="viewer">
        <!-- <img [src]="image" #zoomImage> -->
        <img  src="data:," [imgName]="image['image']" imgType="products"  #zoomImage
         imgSize="lg" imagePreload alt = "{{image['description']}}"/>
    </div>    
</div>